/*
*
* File JS per il template Archive Guests
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroBig from 'components/hero-big/hero-big';
import archiveFilters from 'components/archive-filters/archive-filters';
import cardGuest from 'components/card-guest/card-guest';

import pagination from 'components/pagination/pagination';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './archive-guest.scss';

//--------------------------------------------------------------------//

// JS SPECIFICO PAGINA
//--------------------------------------------------------------------//
/*
const manageFilters = () => {
    let btnSearch = document.querySelector('.guest-filters__cta > a');
    let allSelect = document.querySelectorAll('.guest-filters__field select');
    let textField = document.querySelector('.guest-filters__field.search-text input');

    if (!btnSearch) return;

    btnSearch.addEventListener('click', (evt) => {
        evt.preventDefault();
        let selectFilters = [];
        let textQuery = textField.value ? textField.value : false;

        allSelect.forEach((el) => {
            if (el.value.length == 0) return;
            selectFilters[el.id.replace('select-', '')] = el.value;
        });

        filterBySelect(selectFilters);
        filterByText(textQuery);
        checkFoundResults();
    });
}

const filterBySelect = (selectFilters) => {
    let allGuests = document.querySelectorAll('.guest-list__item');

    if (!allGuests.length) return;

    allGuests.forEach((el) => {
        let elAward = el.dataset.award.split(',');
        let elJob = el.dataset.job.split(',');

        let hasAward = true;
        let hasJob = true;
        
        // CHECK IF FILTER VALUE IS IN EVENT DATA ATTR
        if (selectFilters['award']) {
            hasAward = elAward.indexOf(selectFilters['award']) >= 0 ? true : false;
        }
        if (selectFilters['job']) {
            hasJob = elJob.indexOf(selectFilters['job']) >= 0 ? true : false;
        }

        // SHOW / HIDE event
        if (hasAward && hasJob)
        {
            el.style.display = 'block';
        }
        else
        {
            el.style.display = 'none';
        }
    });
}

const filterByText = (searchQuery) => {

    if (!searchQuery) return;

    let allGuests = document.querySelectorAll('.guest-list__item');

    allGuests.forEach((el) => {
        if (el.style.display == 'block')
        {
            let guestTextContent = el.textContent.toLowerCase();

            if(guestTextContent.includes(searchQuery.toLowerCase())) {
                el.style.display = 'block';
            } else {
                el.style.display = 'none';
            }
        }
    });
}

const checkFoundResults = () => {
    let allGuests = document.querySelectorAll('.guest-list__item');

    if (!allGuests.length) return;

    let resultHasGuests = [];

    allGuests.forEach((guest, index) => {
        if (guest.style.display == 'block')
        {
            resultHasGuests[index] = guest;
        }
    });

    if (!resultHasGuests.length)
    {
        document.querySelector('.guest-list__not-guest').style.display = 'block';
    } 
    else
    {
        document.querySelector('.guest-list__not-guest').style.display = 'none';
    }
}
*/

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

// manageFilters();
archiveFilters();

//--------------------------------------------------------------------//